export default "__VITE_ASSET__mtUIZyGL__"